import React, { useContext, useState } from "react";

//global state
import { StateContext } from "../../AppStateContext";

//helpers
import { getSchema } from "./helpers";

//components
import DisplayQuerySchemaModal from "./DisplaySchemaModal";

//style
import "./Module.css";

const ViewSchemaButton = () => {
  const [schema, setSchema] = useState();
  const [isQuerySchemaModalOpen, setIsQuerySchemaModalOpen] = useState(false);

  //consume global state
  const state = useContext(StateContext);

  const displaySchema = async () => {
    try {
      if (!schema) {
        await getSchema(state, setSchema);
      }

      setIsQuerySchemaModalOpen(true);
    } catch (err) {
      console.error("ERROR ViewSchemaButton::displaySchema::Error", err);
    }
  };
  return (
    <div>
      <button id="querySchemaButton" className="__querySchemaButton" onClick={displaySchema}>
        Schema
      </button>
      <DisplayQuerySchemaModal
        isQuerySchemaModalOpen={isQuerySchemaModalOpen}
        setIsQuerySchemaModalOpen={setIsQuerySchemaModalOpen}
        schema={schema}
      />
    </div>
  );
};

export default ViewSchemaButton;
